export default {
  'area-activations-in-out': 'области (время входа/выхода)',
  'area-activations': 'активации области',
  'area-records': 'записи области',
  'audit-logs': 'журнал действий',
  'body-cluster-events': 'события кластера силуэтов',
  'body-clusters': 'кластеры силуэтов',
  'body-events': 'события с силуэтами',
  'car-cards': 'карточки ТС',
  'car-cluster-events': 'события кластера ТС',
  'car-clusters': 'кластеры ТС',
  'car-episodes': 'эпизоды с ТС',
  'car-events': 'события с ТС',
  'face-cluster-events-in-out': 'события кластера лиц (время входа/выхода)',
  'face-cluster-events': 'события кластера лиц',
  'face-clusters': 'кластеры лиц',
  'face-events-in-out': 'события с лицами (время входа/выхода)',
  'face-events': 'события с лицами',
  'human-cards': 'карточки людей',
  'human-episodes': 'эпизоды с людьми',
  'remote-monitoring-events': 'события удаленного мониторинга',
  lines: 'линии',
  areas: 'области',
  cameras: 'камеры',
  completed: 'завершено',
  counters: 'счётчики',
  'counter-records': 'записи счётчиков',
  csv: 'CSV',
  delete: 'удалить',
  download: 'скачать',
  downloading_report: 'Скачивание отчёта',
  downloading_reports: 'Скачивание отчётов',
  error: 'ошибка',
  fullframe: 'полный кадр',
  gb: 'Гбайт',
  id: 'ID',
  json: 'JSON',
  kb: 'кбайт',
  link: 'ссылка',
  mb: 'МБ',
  modified: 'изменено',
  name: 'имя',
  processing: 'обработка',
  records: 'записи',
  alerts: 'тревоги',
  report_by_audit_logs: 'отчёт по журналу действий',
  report_by_body_clusters: 'отчёт по кластерам силуэтов',
  report_by_body_events: 'отчёт по событиям с силуэтами',
  report_by_cameras: 'отчёт по камерам',
  report_by_car_cards: 'отчёт по карточкам ТС',
  report_by_car_clusters: 'отчёт по кластерам ТС',
  report_by_counter_records: 'отчёт по записям счётчиков',
  report_by_car_episodes: 'отчёт по эпизодам с ТС',
  report_by_car_events: 'отчёт по событиям с ТС',
  report_by_counters: 'отчёт по счётчикам',
  report_by_face_clusters: 'отчёт по кластерам лиц',
  report_by_face_events_in_out: 'отчёт по событиям с лицами (время входа/выхода)',
  report_by_face_events: 'отчёт по событиям с лицами',
  report_by_human_cards: 'отчёт по карточкам людей',
  report_by_human_episodes: 'отчёт по эпизодам с людьми',
  report_by_lines: 'отчёт по пересечениям линий',
  report_by_remote_monitoring_events: 'отчёт по событиям удаленного мониторинга',
  report_by_alerts: 'отчёт по тревогам',
  report_format: 'формат отчёта',
  report_type: 'тип отчёта',
  report: 'отчёт',
  reports_page: 'страницу отчётов',
  save_report_images_as: 'сохранить изображения в отчёте как',
  scheduled: 'запланировано',
  size: 'размер',
  standard_report: 'стандартный отчёт',
  work_time_report: 'учёт рабочего времени',
  camera_entry: 'камера входа',
  camera_exit: 'камера выхода',
  status: 'статус',
  successful_report_creation: 'Отчёт сформирован. Перейти на',
  thumbnail: 'миниатюра | миниатюры',
  type: 'тип',
  update: 'обновить',
  xls: 'XLS',
  pdf: 'PDF',
  docx: 'DOCX',
  analytic_select_data: 'выберите данные для включения в отчёт',
  analytic_output_data: 'итоговые данные',
  analytic_input_data: 'исходные данные для графиков',
  custom: 'пользовательский',
  uploaded: 'загружено',
  prepared: 'подготовлено',
  report_by_area_activations_in_out: 'отчет по областям (время входа/выхода)',
  report_by_area_activations: 'отчет по активациям области',
  report_by_area_records: 'отчет по записям области',
  report_by_areas: 'отчет по областям',
  id_areas: 'ID области'
};
